import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "app-wrapper with-padding-top" }

import { computed, ref, PropType, Ref, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { getStationBarrierGateInfo, upsertStationBarrierGate } from '@/api/operation'
import { ElInput, ElMessage } from 'element-plus'
import { BarrierGateCouponType, BarrierGateType } from '@/types/types'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import FormRulesFactory from '@/common/formRules'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'BarrierGate',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  station: {
    type: Object,
    default: () => { },
  },
},
  setup(__props) {

const props = __props

const { barrierGateCouponTypes, BarrierGateTypes } = useProtocolEnums()
const { t } = useI18n()



const formCom = ref()
const isSubmitting = ref(false)
const configLoading = ref(false)
const formData: Ref<Record<string, any>> = ref({})
const stationFormRules = ref({})

const submit = async () => {
  console.log('submit')
  try {
    await formCom.value.validate()

    console.log('submit3')
    await upsertStationBarrierGate(formData.value)
    ElMessage.success(t(`Base.updateSuccess`))
    loadData()
  } catch (error) {
    //
  } finally {
    isSubmitting.value = false
  }
}

const loadData = async () => {
  try {
    configLoading.value = true
    formData.value = await getStationBarrierGateInfo({
      stationId: props.station.id,
    })
  } catch (error) {
    console.log('--->load error: ', error)
  } finally {
    configLoading.value = false
  }
}

loadData()

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { class: "app-card allow-overflow" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "formCom",
          ref: formCom,
          "label-position": "top",
          "require-asterisk-position": "right",
          model: formData.value,
          rules: stationFormRules.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('Base.enable'),
                      prop: "enable",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: formData.value.enable,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.enable) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (formData.value.enable)
              ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 0,
                  gutter: 20
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: _unref(t)('Operation.barrierGateType'),
                          prop: "barrierGateType",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: formData.value.barrierGateType,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.barrierGateType) = $event)),
                              clearable: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(BarrierGateTypes), (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    label: item.label,
                                    value: item.value,
                                    key: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    (formData.value.barrierGateType > 0)
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 0,
                          span: 12
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: _unref(t)('Operation.appid'),
                              prop: "appId"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElInput), {
                                  modelValue: formData.value.appId,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.appId) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (formData.value.barrierGateType > 0)
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 1,
                          span: 12
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: _unref(t)('Base.address'),
                              prop: "url"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElInput), {
                                  modelValue: formData.value.url,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.url) = $event)),
                                  placeholder: "https://***.jslife.com.cn/openApi"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (formData.value.barrierGateType > 0)
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 2,
                          span: 12
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: _unref(t)('Operation.singKey'),
                              prop: "signKey"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElInput), {
                                  modelValue: formData.value.signKey,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.signKey) = $event)),
                                  type: "textarea",
                                  rows: 1
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (formData.value.barrierGateType == _unref(BarrierGateType).BGT_LTY)
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 3,
                          span: 12
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: _unref(t)('Operation.merchantId'),
                              prop: "merchantId"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElInput), {
                                  modelValue: formData.value.merchantId,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.merchantId) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (formData.value.barrierGateType == _unref(BarrierGateType).BGT_LTY)
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 4,
                          span: 12
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: _unref(t)('Operation.couponId'),
                              prop: "couponId"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElInput), {
                                  modelValue: formData.value.couponId,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.couponId) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (formData.value.barrierGateType == _unref(BarrierGateType).BGT_JS)
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 5,
                          span: 12
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: _unref(t)('Operation.abilityCode'),
                              prop: "abilityCode"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElInput), {
                                  modelValue: formData.value.abilityCode,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.abilityCode) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (formData.value.barrierGateType == _unref(BarrierGateType).BGT_JS)
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 6,
                          span: 12
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: _unref(t)('Operation.mctid'),
                              prop: "customerID"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElInput), {
                                  modelValue: formData.value.customerID,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.customerID) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (formData.value.barrierGateType == _unref(BarrierGateType).BGT_JS)
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 7,
                          span: 12
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: _unref(t)('Operation.parkCode'),
                              prop: "parkCode"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElInput), {
                                  modelValue: formData.value.parkCode,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.parkCode) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (formData.value.barrierGateType == _unref(BarrierGateType).BGT_JS)
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 8,
                          span: 12
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: _unref(t)('Operation.barrierGateCouponType'),
                              prop: "couponType"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: formData.value.couponType,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.couponType) = $event)),
                                  clearable: ""
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(barrierGateCouponTypes), (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        label: item.label,
                                        value: item.value,
                                        key: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (
            (formData.value.couponType == _unref(BarrierGateCouponType).HEJT_AMOUNT ||
              formData.value.couponType == _unref(BarrierGateCouponType).HEJT_TIME) && formData.value.barrierGateType == _unref(BarrierGateType).BGT_JS
          )
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 9,
                          span: 12
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: formData.value.couponType == _unref(BarrierGateCouponType).HEJT_AMOUNT
              ? _unref(t)('Operation.couponAmount')
              : _unref(t)('Operation.couponTime')
              ,
                              prop: "couponValue"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ElInput), {
                                  modelValue: formData.value.couponValue,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.couponValue) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_row, {
              gutter: 20,
              style: {"margin-top":"30px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      disabled: !_ctx.$hasPermission('post'),
                      loading: isSubmitting.value,
                      onClick: submit
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('Base.saveChanges')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    })
  ]))
}
}

})